import * as signalR from '@microsoft/signalr';
import { API_BASE, TIFOXR_TOKEN_KEY } from '../api/apiConfig';

let connection = null;
const listeners = {};

function applyListeners() {
  if (!connection) return;
  Object.entries(listeners).forEach(([event, fns]) => {
    fns.forEach((fn) => connection.on(event, fn));
  });
}

export const signalRService = {
  start: async () => {
    const s = connection?.state;
    if (
      s === signalR.HubConnectionState.Connected ||
      s === signalR.HubConnectionState.Connecting ||
      s === signalR.HubConnectionState.Reconnecting
    ) return;

    connection = new signalR.HubConnectionBuilder()
      .withUrl(`${API_BASE}/hubs/content-approval`, {
        accessTokenFactory: () => localStorage.getItem(TIFOXR_TOKEN_KEY) || '',
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Warning)
      .build();

    await connection.start();
    applyListeners(); // must run AFTER start() — listeners are registered via on() between start() call and connection ready
  },

  stop: async () => {
    if (connection) {
      await connection.stop();
      connection = null;
    }
  },

  on: (event, fn) => {
    if (!listeners[event]) listeners[event] = [];
    if (!listeners[event].includes(fn)) {
      listeners[event].push(fn);
    }
    if (connection?.state === signalR.HubConnectionState.Connected) {
      connection.on(event, fn);
    }
  },

  off: (event, fn) => {
    if (listeners[event]) {
      listeners[event] = listeners[event].filter((f) => f !== fn);
    }
    connection?.off(event, fn);
  },
};
